import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import PitBox from './pitBox';
import FoodBox from './foodBox';

class PGNews extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { pitData, foodData, pitAndFoodAd },
        } = this.props;

        return (
            <div className={styles.box}>
                <div className="clearfix">
                    <PitBox content={pitData} />
                    <FoodBox content={foodData} />
                </div>
                {pitAndFoodAd ? <Ad content={pitAndFoodAd} styleName={styles.ad} /> : ''}
            </div>
        );
    }
}

export default errorBoundary(PGNews);
